import { HistoryFilterOptions } from '#shared/types/common';

export const ONBOARDING_PROCESS_FILTER_PARAMS: HistoryFilterOptions = {
  offset: 0,
  limit: 2,
  sort: 'desc(startTime)',
};
